import { render, staticRenderFns } from "./VT.vue?vue&type=template&id=3138125a"
import script from "./VT.vue?vue&type=script&lang=js"
export * from "./VT.vue?vue&type=script&lang=js"
import style0 from "./VT.vue?vue&type=style&index=0&id=3138125a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports